import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  programsWrapper: {},
  headerTooltip: {
    [theme.breakpoints.up('md')]: {
      marginRight: theme.spacing(2),
    },
  },
  tabsContent: {},
  programsAddButton: {
    minWidth: 'unset',
    fontSize: '40px',
    fontWeight: 600,
    padding: 0,
    lineHeight: '35px',
  },
  buttonWeb: {
    display: 'block',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  buttonMobile: {
    display: 'none',
    marginRight: '8px',
    [theme.breakpoints.down('md')]: {
      display: 'block',
    },
  },
}));
